/* One Tap. — moteur d'animations global
   - apparitions au scroll ([data-reveal] + sélection automatique)
   - titres découpés mot par mot ([data-split] + tous les h2 de <main>)
   - compteurs animés ([data-count])
   - effet 3D au survol ([data-tilt])
   - header qui se cache au scroll vers le bas
   - défilement fluide (Lenis, desktop uniquement)
   - transition douce entre les pages */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  var AUTO_REVEAL = [
    '.ot-steps__item', '.ot-faq__item', '.ot-gua__item', '.ot-gua__tagline',
    '.ot-logos__item', '.ot-vt__item', '.ot-it__media', '.ot-it__content',
    '.ot-use__card', '.ot-stat', '.ot-fp__media', '.ot-fp__info',
    '.ot-cta__inner', '.ot-rev__app', '.ot-logos__heading', '.ot-main__grid > *'
  ].join(',');

  /* ---------- Découpage des titres en mots ---------- */
  function split(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'ot-w';
            var inner = document.createElement('span'); inner.className = 'ot-wi';
            inner.style.setProperty('--i', i++);
            inner.textContent = p;
            w.appendChild(inner); frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR' && child.tagName !== 'SVG' && child.tagName !== 'I') {
          walk(child);
        }
      });
    })(el);
  }

  /* ---------- Compteurs ---------- */
  function count(el) {
    var target = parseFloat(el.dataset.count);
    if (isNaN(target)) return;
    var decimals = (el.dataset.count.split('.')[1] || '').length;
    var start = performance.now(), dur = 1600;
    function frame(t) {
      var p = Math.min(1, (t - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Apparitions ---------- */
  var io = ('IntersectionObserver' in window) && !reduce && !designMode
    ? new IntersectionObserver(function (entries) {
        var batch = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          if (!el.style.getPropertyValue('--rd')) el.style.setProperty('--rd', Math.min(batch++ * 90, 450) + 'ms');
          el.classList.add('is-in');
          if (el.hasAttribute('data-count')) count(el);
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
    : null;

  function init(scope) {
    scope = scope || document;
    var main = scope.querySelector ? (scope.querySelector('main') || scope) : document;
    main.querySelectorAll('h2:not([data-no-split]), [data-split]').forEach(function (h) {
      split(h);
      if (!h.hasAttribute('data-reveal')) h.setAttribute('data-reveal', 'text');
    });
    main.querySelectorAll(AUTO_REVEAL).forEach(function (el) {
      if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
    });
    var targets = scope.querySelectorAll('[data-reveal]:not(.is-in), [data-count]');
    targets.forEach(function (el) {
      if (io) io.observe(el);
      else { el.classList.add('is-in'); }
    });
    if (finePointer && !reduce) scope.querySelectorAll('[data-tilt]').forEach(tilt);
  }

  /* ---------- Effet 3D ---------- */
  function tilt(el) {
    if (el.dataset.tiltReady) return;
    el.dataset.tiltReady = '1';
    var max = parseFloat(el.dataset.tilt) || 8;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      el.style.transform = 'perspective(900px) rotateX(' + (-y * max) + 'deg) rotateY(' + (x * max) + 'deg) scale(1.02)';
      el.style.setProperty('--gx', (x + .5) * 100 + '%');
      el.style.setProperty('--gy', (y + .5) * 100 + '%');
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  /* ---------- Header intelligent ---------- */
  function header() {
    var h = document.querySelector('.ot-section-header');
    if (!h) return;
    var last = window.scrollY, ticking = false;
    function update() {
      var y = window.scrollY;
      h.classList.toggle('is-scrolled', y > 10);
      var open = h.querySelector('details[open]');
      if (!open && y > 160 && y > last + 4) h.classList.add('is-hidden');
      else if (y < last - 4 || y < 160) h.classList.remove('is-hidden');
      last = y; ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Défilement fluide ---------- */
  function smooth() {
    if (reduce || designMode || !finePointer || !window.Lenis) return;
    var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true, wheelMultiplier: 1 });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    window.otLenis = lenis;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      lenis.scrollTo(t, { offset: -20 });
    });
  }

  /* ---------- Transition entre les pages ---------- */
  function pageTransitions() {
    if (reduce || designMode) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash)) return;
      if (a.getAttribute('href').charAt(0) === '#') return;
      e.preventDefault();
      doc.classList.add('ot-leaving');
      setTimeout(function () { location.href = a.href; }, 220);
    });
    window.addEventListener('pageshow', function () { doc.classList.remove('ot-leaving'); });
  }

  doc.classList.add('ot-js');
  if (reduce || designMode) doc.classList.add('ot-no-motion');

  function boot() {
    init(document);
    header();
    smooth();
    pageTransitions();
    requestAnimationFrame(function () { doc.classList.add('ot-ready'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
